export const BUSINESS_UNIT = {
    BASE_PATH: '/customer/business-unit/',
    GET_ALL: '/business-unit',
    CREATE: '/business-unit/create',
    UPDATE: '/business-unit/update/',
    DELETE: '/business-unit/delete/',
};
